// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2ccEG","rootSuccess":"CompleteLink_rootSuccess__35lmT","rootFailure":"CompleteLink_rootFailure__1U8gK","isDisabled":"CompleteLink_isDisabled__2wXhF"};